/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagBIcon24Solid = forwardRef('FlagBIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.486 2.126C9.382.402 6.21.292 3.08 1.829A1.952 1.952 0 0 0 2 3.59V22.5a1.5 1.5 0 0 0 3 0v-6.312c2.175-.76 4.323-.531 6.514.686 3.204 1.78 6.474 1.836 9.69.152.503-.263.796-.78.796-1.32V3.425c0-.97-1.024-1.526-1.83-1.116-2.57 1.31-5.093 1.256-7.684-.183Z" })));
});
